import CleverPushError from './CleverPushError';

export default class SubscribingInProgressError extends CleverPushError {}
